import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public getErrorMessage(): string {
    let result = 'An error has occured.';

    const { errorMessage } = window.history.state;

    if (!_.isNil(errorMessage) && errorMessage !== '') {
      result = errorMessage;
    }

    return result;
  }
}
